import type { MapFiltersType } from '~/atoms'
import {
  ReportPdfType,
  type Company,
  type Listing,
  type ListingBroker,
  type Organization,
  type ParcelFeature,
  type ReportPdfOptions,
  type User,
} from '~/models'
import ReportComparisonPdf from './Comparison'
import ReportFlyersPdf from './Flyers'
import ReportLeaseCompPdf from './LeaseComp'
import ReportLeasedCompsPdf from './LeasedComps'
import ReportSaleCompPdf from './SaleComp'
import ReportSoldCompsPdf from './SoldComps'
import ReportSummaryPdf from './Summary'

export type ReportPdfSwitchProps = {
  organization: Organization
  filters: MapFiltersType | undefined
  title: string
  user: User
  brokers?: ListingBroker[]
  company?: Company
  listings: Listing[]
  parcels: ParcelFeature[]
  pdfOptions: ReportPdfOptions
}

export default function ReportPdfSwitch({ ...props }: ReportPdfSwitchProps) {
  if (props.pdfOptions.type === ReportPdfType.flyers) {
    return <ReportFlyersPdf {...props} />
  } else if (props.pdfOptions.type === ReportPdfType.summary) {
    return <ReportSummaryPdf {...props} />
  } else if (props.pdfOptions.type === ReportPdfType.comparison) {
    return <ReportComparisonPdf {...props} />
  } else if (props.pdfOptions.type === ReportPdfType.soldComps) {
    return <ReportSoldCompsPdf {...props} />
  } else if (props.pdfOptions.type === ReportPdfType.leasedComps) {
    return <ReportLeasedCompsPdf {...props} />
  } else if (props.pdfOptions.type === ReportPdfType.saleComp) {
    return <ReportSaleCompPdf {...props} />
  } else if (props.pdfOptions.type === ReportPdfType.leaseComp) {
    return <ReportLeaseCompPdf {...props} />
  }
  return null
}
